export const selectIsFetching = state => state.isFetching;
export const selectItems = state => state.items || [];
export const selectQuery = state => state.query ?? '';
